import { useState } from 'react';
import { cn } from '@/lib/utils';

import { getDispositionColor } from '@/shared/lib/colors';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

type DispositionBadgeProps = {
  disposition: string;
  dispositions?: string[];
  isEditable?: boolean;
  onChange?: (newDisposition: string) => void;
}

export function DispositionBadge(
  {
    disposition,
    dispositions = [],
    isEditable = false,
    onChange
  }: DispositionBadgeProps) {
  const [isOpen, setIsOpen] = useState(false);
  const colorClass = getDispositionColor(disposition);
  const badgeClass = "inline-flex items-center px-2 py-0.5 rounded text-detail font-medium";

  if (!isEditable || dispositions.length === 0) {
    return (
      <div className={cn(badgeClass, colorClass)}>
        {disposition}
      </div>
    );
  }

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <div className={cn(badgeClass, colorClass, "cursor-pointer hover:ring-1 hover:ring-gray-300")}>
          {disposition}
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-[120px]">
        {dispositions.map((d) => (
          <DropdownMenuItem
            key={d}
            className="text-detail"
            onClick={() => {
              onChange?.(d);
              setIsOpen(false);
            }}
          >
            {d}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}